import { render, staticRenderFns } from "./neuebestellung.vue?vue&type=template&id=68fa75b2&scoped=true&"
import script from "./neuebestellung.vue?vue&type=script&lang=js&"
export * from "./neuebestellung.vue?vue&type=script&lang=js&"
import style0 from "./neuebestellung.vue?vue&type=style&index=0&id=68fa75b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa75b2",
  null
  
)

export default component.exports